import React from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  DatePicker,
  FormInput,
  FormSelect,
  FormTextarea,
  Button,
} from "shards-react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import { TiDeleteOutline } from "react-icons/ti";
import ProjectDataService from "../../services/project.service";
import { FcPlus } from "react-icons/fc";
import nav_store, {
  types as nav_types,
  actions as nav_actions,
} from "../../_stores/sidenav.store";
import {actions as AppActions} from "../../_stores/app.store";

const productApiKeys = ['VER_VENDORID',
                        'RETAILER_ID',
                        'DATA_TYPE',
                        'COMP_CODE',
                        'COMP_NAME',
                        'SALT_NAME',
                        'DRUG_TYPE',
                        'PROD_CODE',
                        'BAR_CODE',
                        'PROD_NAME',
                        'PACK_SIZE',
                        'CONVERSION',
                        'UOM',
                        'PUR_RATE',
                        'MRP',
                        'HSNCODE',
                        'GST',
                        'REMARK'];
const sasApiKeys = [
                    'RECORD_TYPE',
                    'VER_VENDORID',
                    'RETAILER_ID',
                    'PERIOD_START_DATE',
                    'PERIOD_END_DATE',
                    'CREATED_DATE',
                    'CREATED_TIME',
                    'PROD_CODE',
                    'BAR_CODE',
                    'COMP_NAME',
                    'PROD_NAME',
                    'OPENING_STOCK',
                    'GOODS_RECEIVED',
                    'GOODS_RECEIVED_FREE',
                    'SALES_RETURN',
                    'SALES_RETURN_FREE',
                    'PURCHASE_RETURN',
                    'PURCHASE_RETURN_FREE',
                    'SALES_QTY',
                    'SALES_FREE_QTY',
                    'ADJUSTMENTS',
                    'CLOSING_STOCK',
                    'CONVERSION',
                    'UOM',
                    'PUR_RATE',
                    'MRP',
                    'EXPIRED',
                    'EXP_UPTO_90',
                    'Remark'  
                  ];


class CreateProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectName: "",
      startDate: undefined,
      countryName: "",
      asset: "",
      fileFormat: "",
      fileDescription: "",
      masterApiKeys:"",
      fileNamingConvention: "",
      maxNumOfFiles: "",
      isMandatoryFile: true,
      dataFrequencyByFileType: "",
      serverPath: "",
      serverUserName: "",
      serverPassword: "",
      serverPortNumber: "",
      serverFolderPath: "",
      showModal:false,
      localStoreData : [],
      fieldName:"",
      apiKey:"",
      apiKeyArray:[],
      dataType:"",
      productFieldSubmit:false,
      productFieldName:{value:"", isValid:false},
      productDataType:{value:"", isValid:false},
      sasFieldSubmit:false,
      sasFieldName:{value:"", isValid:false},
      sasDataType:{value:"", isValid:false},
      localStoreFieldData: [],
      productFieldKeys:[],
      sasFieldKeys:[],
      productKeysArray:[],
      sasKeysArray:[]
    };

    this.state.localStoreData = JSON.parse(
      localStorage.getItem("addFormDataArr")
    );
    this.state.localStoreFieldData = JSON.parse(
      localStorage.getItem("addFieldDataArr")
    );

    this.onChangeProjectName = this.onChangeProjectName.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.onChangeCountryName = this.onChangeCountryName.bind(this);
    this.onChangeAsset = this.onChangeAsset.bind(this);
    this.onChangeFileFormat = this.onChangeFileFormat.bind(this);
    this.onChangeFileDescription = this.onChangeFileDescription.bind(this);
    this.onChangeMasterApiKeys = this.onChangeMasterApiKeys.bind(this);
    this.onChangeFileNamingConvention = this.onChangeFileNamingConvention.bind(this);
    this.onChangeMaxNumOfFiles = this.onChangeMaxNumOfFiles.bind(this);
    this.onChangeIsMandatoryFile = this.onChangeIsMandatoryFile.bind(this);
    this.onChangeDataFrequencyByFileType = this.onChangeDataFrequencyByFileType.bind(this);
    this.onChangeServerPath = this.onChangeServerPath.bind(this);
    this.onChangeServerUserName = this.onChangeServerUserName.bind(this);
    this.onChangeServerPassword = this.onChangeServerPassword.bind(this);
    this.onChangeServerPortNumber = this.onChangeServerPortNumber.bind(this);
    this.onChangeServerFolderPath = this.onChangeServerFolderPath.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleAddFileForm = this.handleAddFileForm.bind(this);
    this.handleAddFieldForm = this.handleAddFieldForm.bind(this);
    this.onChangeFieldName = this.onChangeFieldName.bind(this);
    this.onChangeApiKey = this.onChangeApiKey.bind(this);
    this.onChangeDataType = this.onChangeDataType.bind(this);
    
    this.onChangeProductFieldName = this.onChangeProductFieldName.bind(this);
    this.onChangeProductDataType = this.onChangeProductDataType.bind(this);
    this.onChangeSasFieldName = this.onChangeSasFieldName.bind(this);
    this.onChangeSasDataType = this.onChangeSasDataType.bind(this);

    this.handleAddProjectForm = this.handleAddProjectForm.bind(this);
    this.handleNewFile = this.handleNewFile.bind(this);
    this.handleAddProductFieldKeys = this.handleAddProductFieldKeys.bind(this);
    this.handleAddSasFieldKeys = this.handleAddSasFieldKeys.bind(this);
    
  }

  componentDidMount() {
   
    localStorage.removeItem("addFormDataArr");
    localStorage.removeItem("addFieldDataArr");
    this.setState({
      localStoreData: [],
      localStoreFieldData: []
    });
  }

  onChangeProjectName(e) {
    this.setState({
      projectName: e.target.value,
    });
  }

  handleStartDateChange(value) {
    this.setState({
      ...this.state,
      ...{ startDate: new Date(value) },
    });
  }

  onChangeCountryName(e) {
    this.setState({
      countryName: e.target.value,
    });
  }

  onChangeAsset(e) {
    this.setState({
      asset: e.target.value,
    });
  }

  onChangeFileFormat(e) {
    this.setState({
      fileFormat: e.target.value,
    });
  }

  onChangeFileDescription(e) {
    this.setState({
      fileDescription: e.target.value,
    });
  }

  onChangeMasterApiKeys(e) {
    this.setState({
      masterApiKeys: e.target.value,
    });

    if(e.target.value === "productMaster" ){
      this.setState({
        apiKeyArray: this.state.productFieldKeys,
      });
    }
    else if(e.target.value === "sasMaster" ){
      this.setState({
        apiKeyArray: this.state.sasFieldKeys,
      });
    }
    else{
      this.setState({
        apiKeyArray: [],
      });
    }
  }

  onChangeFileNamingConvention(e) {
    this.setState({
      fileNamingConvention: e.target.value,
    });
  }

  onChangeMaxNumOfFiles(e) {
    this.setState({
      maxNumOfFiles: e.target.value,
    });
  }

  onChangeIsMandatoryFile(e) {
    this.setState({
      isMandatoryFile: e,
    });
  }

  onChangeDataFrequencyByFileType(e) {
    this.setState({
      dataFrequencyByFileType: e.target.value,
    });
  }

  onChangeServerPath(e) {
    this.setState({
      serverPath: e.target.value,
    });
  }

  onChangeServerUserName(e) {
    this.setState({
      serverUserName: e.target.value,
    });
  }

  onChangeServerPassword(e) {
    this.setState({
      serverPassword: e.target.value,
    });
  }

  onChangeServerPortNumber(e) {
    this.setState({
      serverPortNumber: e.target.value,
    });
  }

  onChangeServerFolderPath(e) {
    this.setState({
      serverFolderPath: e.target.value,
    });
  }

  handleShowModal() {
    this.setState({
      showModal: true,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
      localStoreFieldData: [],
      fileFormat: "",
      fileDescription: "",
      fileNamingConvention: "",
      maxNumOfFiles: "",
      isMandatoryFile: false,
      dataFrequencyByFileType: "",
      fieldName: "",
      dataType: "",
    });
  }

  handleNewFile(){
    localStorage.removeItem("addFieldDataArr");
    this.setState({
      showModal: true,
    });
  }

  handleAddFileForm() {
    // alert();

    var addFormDataArr = [];
    var addFieldDataArr = [];

    if (localStorage.getItem("addFormDataArr"))
      addFormDataArr = JSON.parse(localStorage.getItem("addFormDataArr"));

    if (localStorage.getItem("addFieldDataArr"))
      addFieldDataArr = JSON.parse(localStorage.getItem("addFieldDataArr"));

    localStorage.removeItem("addFormDataArr");
    
    var addFormData = {
      fileFormat: this.state.fileFormat,
      fileDescription: this.state.fileDescription,
      fileNamingConvention: this.state.fileNamingConvention,
      masterApiKeys: this.state.masterApiKeys,
      maxNumOfFiles: this.state.maxNumOfFiles,
      isMandatoryFile: this.state.isMandatoryFile,
      dataFrequencyByFileType: this.state.dataFrequencyByFileType,
      masterTableFields: addFieldDataArr,
    };

    addFormDataArr.push(addFormData);
    localStorage.setItem("addFormDataArr", JSON.stringify(addFormDataArr));
    this.setState({
      localStoreData: JSON.parse(localStorage.getItem("addFormDataArr")),
    });

    localStorage.removeItem("addFieldDataArr");
    this.handleCloseModal();
  }

  onChangeFieldName(e) {
    this.setState({
      fieldName: e.target.value,
    });
  }
  
  onChangeApiKey(e) {
    this.setState({
      apiKey: e.target.value,
    });
  }

  onChangeDataType(e) {
		this.setState({
			dataType: e.target.value,
		});
	}

  onChangeProductFieldName(e) {
    let isValid = e.target.value ? true : false
    this.setState({
      productFieldName:{
        ...this.state.productFieldName,
        value: e.target.value,
        isValid: isValid
      }
    });
  }

  onChangeProductDataType(e) {
    let isValid = e.target.value ? true : false
    this.setState({
      productDataType:{
        ...this.state.productDataType,
        value: e.target.value,
        isValid: isValid
      }
    });
  }

  onChangeSasFieldName(e) {
    let isValid = e.target.value ? true : false
    this.setState({
      sasFieldName:{
        ...this.state.sasFieldName,
        value: e.target.value,
        isValid: isValid
      }
    });
  }

  onChangeSasDataType(e) {
    let isValid = e.target.value ? true : false
    this.setState({
      sasDataType:{
        ...this.state.sasDataType,
        value: e.target.value,
        isValid: isValid
      }
    });
  }


  handleAddFieldForm() {
    // alert();
     
     var addFieldDataArr=[]; 
 
   
     if(localStorage.getItem("addFieldDataArr"))
     addFieldDataArr = JSON.parse(localStorage.getItem("addFieldDataArr"));
 
     localStorage.removeItem("addFieldDataArr");
     
     var addFieldata = {
       fieldName: this.state.fieldName,
       apiKey: this.state.apiKey,
       dataType: this.state.dataType
     }
     
     addFieldDataArr.push(addFieldata);
     localStorage.setItem('addFieldDataArr', JSON.stringify(addFieldDataArr));
     this.setState({
      localStoreFieldData: JSON.parse(localStorage.getItem("addFieldDataArr")),
      fieldName:"",
      apiKey:"",
     });
   }

  newProjectForm() {
    this.setState({
      projectName: "",
      startDate: "",
      countryName: "",
      asset: "",
      serverPath: "",
      serverUserName: "",
      serverPassword: "",
      serverPortNumber: "",
      serverFolderPath: "",
      files: "",
      localStoreData: [],
    });
  }

  handleAddProjectForm() {
    if (localStorage.getItem("addFormDataArr"))
      var addFormDataArr = JSON.parse(localStorage.getItem("addFormDataArr"));

    var data = {
      projectName: this.state.projectName,
      startDate: this.state.startDate,
      countryName: this.state.countryName,
      asset: this.state.asset,
      serverPath: this.state.serverPath,
      serverUserName: this.state.serverUserName,
      serverPassword: this.state.serverPassword,
      serverPortNumber: this.state.serverPortNumber,
      serverFolderPath: this.state.serverFolderPath,
      productFieldKeys:this.state.productFieldKeys,
      sasFieldKeys:this.state.sasFieldKeys,
      files: addFormDataArr,
    };
    
    AppActions.setLoading(true);
    ProjectDataService.create(data)
    .then((response) => {
      AppActions.setLoading(false);
      if(response.data.success){ // check for success
        this.newProjectForm();
        var notify_message =({
          type:"success",
          message:"Project has been created successfully."
        });
        localStorage.removeItem("addFormDataArr");
        nav_actions.setSideNav(nav_store.dispatch, {});

      }else{
        if(response.data.err.message){ // fields error
          var notify_message =({
            type:"error",
            message:response.data.err.message
          });
        }
        else{ // mongo error
          var notify_message =({ 
            type:"error",
            message:response.data.err.name + " - May be duplicate record"
          });
        }
      }
      this.props.redirectToProjectDetails("/project/" + response.data.data.id, notify_message);
    })
  }


  handleAddProductFieldKeys(){
    this.setState({
      productFieldSubmit: true
    })
    
    if(this.state.productFieldName.isValid  && this.state.productDataType.isValid) 
    {
      var productKeys = {};
      productKeys.fieldName = this.state.productFieldName.value;
      productKeys.dataType = this.state.productDataType.value;
     
      this.state.productKeysArray.push(productKeys); 
      this.setState({
        productFieldKeys : this.state.productKeysArray,
        productFieldName:{
          value : "",
          isValid: false
        },
        productFieldSubmit: false
      })
    }
  
  
  } 
  handleAddSasFieldKeys(){
    this.setState({
      sasFieldSubmit: true
    })
    if(this.state.sasFieldName.isValid  && this.state.sasDataType.isValid) 
    {
    var sasKeys = {};
    
    sasKeys.fieldName = this.state.sasFieldName.value;
    sasKeys.dataType = this.state.sasDataType.value;
    this.state.sasKeysArray.push(sasKeys); 

    this.setState({
      sasFieldKeys : this.state.sasKeysArray,
      sasFieldName: {
        value : "",
        isValid: false
      },
      sasFieldSubmit: false
      })
    }
  }
  

  deleteFromLocalStorage(fieldNameData){
   // alert(fieldNameData);
    let data = JSON.parse(localStorage.getItem("addFieldDataArr"))
    let deleteindex;
    // Get index of object
     data.find(function(item, i){
      
      if(item.fieldName == fieldNameData){
        deleteindex = i;
       // 
      }
    });

    data.splice(deleteindex, 1)
    // Splice the array at the index of your object
   
    // Save back to localStorage
    localStorage.setItem("addFieldDataArr", JSON.stringify(data)); 
    this.setState({
      localStoreFieldData: JSON.parse(localStorage.getItem("addFieldDataArr"))
     });
  }

  deleteProductFieldName(fieldName){
    var data = this.state.productFieldKeys.filter(function(item){
      return item.fieldName !== fieldName
    });
    this.setState({
     productFieldKeys:data
     });
  }

  deleteSasFieldName(fieldName){
    var data = this.state.sasFieldKeys.filter(function(item){
      return item.fieldName !== fieldName
    });
     this.setState({
      sasFieldKeys:data
      });
   }

   

  render() {
    const {
         showModal,
        localStoreData,
        localStoreFieldData,
        productFieldKeys,
        sasFieldKeys,
        apiKeyArray
    } = this.state;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Create New Project</h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Project Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="projectName"
                          placeholder="Project Name"
                          value={this.state.projectName}
                          onChange={this.onChangeProjectName}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Start Date</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleStartDateChange}
                          placeholderText="Start Date"
                          dropdownMode="select"
                          className="text-center col-md-12"
                          md="8"
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Country Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="feName"
                          placeholder="Country Name"
                          value={this.state.countryName}
                          onChange={this.onChangeCountryName}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Asset</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="feName"
                          placeholder="Asset"
                          value={this.state.asset}
                          onChange={this.onChangeAsset}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">
                          File Location Configuration
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <FormInput
                              id="serverPath"
                              placeholder="Server Path"
                              value={this.state.serverPath}
                              onChange={this.onChangeServerPath}
                            />
                          </Col>
                          <Col className="form-field" md="3">
                            <FormInput
                              id="serverPortNumber"
                              placeholder="Port"
                              value={this.state.serverPortNumber}
                              onChange={this.onChangeServerPortNumber}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="serverUsername"
                              placeholder="Server User Name"
                              value={this.state.serverUserName}
                              onChange={this.onChangeServerUserName}
                            />
                          </Col>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="serverPassword"
                              type="password"
                              placeholder="Server Password"
                              value={this.state.serverPassword}
                              onChange={this.onChangeServerPassword}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="form-field" md="12">
                            <FormInput
                              id="folderPath"
                              placeholder="Folder Path"
                              value={this.state.serverFolderPath}
                              onChange={this.onChangeServerFolderPath}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="form-group-row border-bottom-button">
                      <Col className="form-label" md="4">
                        <label htmlFor="masterTransactionFields">Product Master Key Fields</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <Row>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="productFieldName"
                              placeholder="Product Key Field Name"
                              value={this.state.productFieldName.value}
                              onChange={this.onChangeProductFieldName} 
                              className={this.state.productFieldSubmit ? this.state.productFieldName.isValid ? "" : "field-error":""}
                            />

                          </Col>
                          <Col className="form-field" md="5">
                            <FormSelect
                              id="productDataType"
                              onChange={this.onChangeProductDataType}
                              className={this.state.productFieldSubmit ? this.state.productDataType.isValid ? "" : "field-error":""}
                            >
                              <option value="">Select Data Type</option>
                              <option value="Number">Number</option>
                              <option value="String">String</option>
                              <option value="Date">Date</option>
                            </FormSelect>
                          </Col>
                          <Col className="form-field" md="1">
                            <Button
                              variant="primary"
                              onClick={this.handleAddProductFieldKeys}
                            >
                              <FcPlus  size="16" /> {/*Add*/}
                            </Button>
                          </Col>
                        </Row>
                        <Row
                            className="form-group-row ml-1 mr-1 border-bottom-button" >
                            <Col className="form-label" md="6">
                              <label htmlFor="filedName">Key Field Name</label>
                            </Col>
                      
                            <Col className="form-label" md="5">
                              <label htmlFor="dataType">Data Type</label>
                            </Col>
                            
                            <Col className="form-label" md="1">
                              <label htmlFor="dataType">Action</label>
                            </Col>
                        </Row>
                        {productFieldKeys &&
                          productFieldKeys.map((item, index) => {
                            return (
                           
                              <Row
                                className="form-group-row ml-1 mr-1 border-bottom-button"
                                key={index + 1}
                              >
                              
                                <Col className="form-field" md="6">
                                  {item.fieldName}
                                </Col>
                                <Col className="form-field" md="5">
                                  {item.dataType}
                                </Col>
                                <Col className="form-label" md="1">
                                  <div className="closeBtn" onClick={this.deleteProductFieldName.bind(this, item.fieldName)} aria-label="Close">
                                    <TiDeleteOutline />
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </Row>

                    <Row className="form-group-row border-bottom-button">
                      <Col className="form-label" md="4">
                        <label htmlFor="masterTransactionFields">SAS Master Key Fields</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <Row>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="fieldName"
                              placeholder="Field Name"
                              value={this.state.sasFieldName.value}
                              onChange={this.onChangeSasFieldName}
                              className={this.state.sasFieldSubmit ? this.state.sasFieldName.isValid ? "" : "field-error":""}
                            />
                          </Col>
                          <Col className="form-field" md="5">
                            <FormSelect
                              id="sasDataType"
                              onChange={this.onChangeSasDataType}
                              className={this.state.sasFieldSubmit ? this.state.sasDataType.isValid ? "" : "field-error":""}
                            >
                              <option>Select Data Type</option>
                              <option value="Number">Number</option>
                              <option value="String">String</option>
                              <option value="Date">Date</option>
                            </FormSelect>
                          </Col>
                          <Col className="form-field" md="1">
                            <Button
                              variant="primary"
                              onClick={this.handleAddSasFieldKeys}
                            >
                              <FcPlus size="16" /> {/*Add*/}
                            </Button>
                          </Col>
                        </Row>
                        <Row
                            className="form-group-row ml-1 mr-1 border-bottom-button" >
                            <Col className="form-label" md="6">
                              <label htmlFor="filedName">Key Field Name</label>
                            </Col>
                      
                            <Col className="form-label" md="5">
                              <label htmlFor="dataType">Data Type</label>
                            </Col>
                            
                            <Col className="form-label" md="1">
                              <label htmlFor="dataType">Action</label>
                            </Col>
                        </Row>
                        {sasFieldKeys &&
                          sasFieldKeys.map((item, index) => {
                            return (
                              <Row
                                className="form-group-row ml-1 mr-1 border-bottom-button"
                                key={index + 1}
                              >
                              
                                <Col className="form-field" md="6">
                                  {item.fieldName}
                                </Col>
                                <Col className="form-field" md="5">
                                  {item.dataType}
                                </Col>
                                <Col className="form-label" md="1">
                                  <div className="closeBtn" onClick={this.deleteSasFieldName.bind(this, item.fieldName)} aria-label="Close">
                                    <TiDeleteOutline />
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-field font-bold" md="12">
                        <label htmlFor="feFirstName">Files Required</label>
                        <Button
                          className="ml-3"
                          variant="primary"
                          onClick={this.handleNewFile}
                        >
                          <FcPlus /> Add Files
                        </Button>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Accordion>
                        {localStoreData &&
                          localStoreData.map((item, index) => {
                            return (
                              <Accordion.Item
                                eventKey={index + 1}
                                datakey={index + 1}
                                key={index + 1}
                              >
                                <Accordion.Header>
                                  File {index + 1}
                                </Accordion.Header>
                                <Accordion.Body>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        File Format
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileFormat}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Files Description
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileDescription}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Master Api Keys
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.masterApiKeys}
                                      </Col>
                                    </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        File Naming Convention
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileNamingConvention}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Maximum Number of Files
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.maxNumOfFiles}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Mandatory Files
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.isMandatoryFile}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Data Frequency By File Type
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.dataFrequencyByFileType}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button">
                                    <Col
                                      className="form-field font-bold"
                                      md="12"
                                    >
                                      <label htmlFor="feFirstName">
                                        Master Transaction Fields
                                      </label>
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button">
                                      <Col className="form-label" md="4">
                                       Field Name
                                      </Col>
                                      <Col className="form-label" md="4">
                                        Master key
                                      </Col>
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Data Type
                                        </label>
                                      </Col>
                                  </Row>
                                  {item.masterTableFields &&
                                    item.masterTableFields.map(
                                      (mtItem, mtIndex) => {
                                        return (
                                          <Row
                                            className="form-group-row border-bottom-button"
                                            key={mtIndex + 1}
                                          >
                                            <Col className="form-field" md="4">
                                              {mtItem.fieldName}
                                            </Col>
                                            <Col className="form-field" md="4">
                                              {mtItem.apiKey}
                                            </Col>
                                            <Col className="form-field" md="4">
                                            {mtItem.dataType}
                                            </Col>
                                            {/* <Col className="form-label" md="2">
                                        <Button variant="primary" size="sm" className="ml-3 btn btn-success" onClick={this.handleAddFileForm}><TiDeleteOutline /></Button></Col> */}
                                          </Row>
                                        );
                                      }
                                    )}
                                  <Row className="mt-2">
                                    {/* <Button variant="primary" onClick={this.handleAddFileForm}>Edit</Button>
                              <Button variant="primary" className="ml-3" onClick={this.handleAddFileForm}>Delete</Button> */}
                                  </Row>
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                      </Accordion>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-button" md="4">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={this.handleAddProjectForm}
                        >
                          <FcPlus /> Create Project
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>

        <Modal show={showModal} size="lg" className="filePopup" onHide={this.handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Add File</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.handleCloseModal}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Format</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="fileFormat"
                    placeholder="File Format"
                    value={this.state.fileFormat}
                    onChange={this.onChangeFileFormat}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Description</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormTextarea
                    id="fileDescription"
                    placeholder="File Descriptions"
                    rows="3"
                    value={this.state.fileDescription}
                    onChange={this.onChangeFileDescription}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4"><label htmlFor="fileType">Master API Keys</label></Col>
                <Col className="form-field" md="8">
                  <FormSelect id="fileType" onChange={this.onChangeMasterApiKeys} value={this.state.masterApiKeys}>
                    <option value="masterApiKeys">Select Master API Key</option>
                    <option value="productMaster">Product Master</option>
                    <option value="sasMaster">SAS Master</option>
                  </FormSelect>
                  </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Naming Convention</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="fileNamingConvention"
                    placeholder="(xxx/x)xxxxxxxxxxxx"
                    value={this.state.fileNamingConvention}
                    onChange={this.onChangeFileNamingConvention}
                  />
                  <div className="text-sm text-muted mt-2">
                    (xxx/x(Maste Type)xxxxxx(SupplierCode)xxxxxx(DD MM YY)<br />
                    For Product Master (PxxxxxxDDMMYY)<br />
                    For SAS Master (SASxxxxxxDDMMYY)
                  </div>
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="maxNumOfFiles">Maximum Number of Files</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="maxNumOfFiles"
                    placeholder="Maximum Number of Files"
                    value={this.state.maxNumOfFiles}
                    onChange={this.onChangeMaxNumOfFiles}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">Mandatory Files</label>
                </Col>
                <Col className="form-field" md="8">
                  <BootstrapSwitchButton
                    id="isMandatoryFile"
                    onlabel="Yes"
                    offlabel="No"
                    onChange={this.onChangeIsMandatoryFile}
                    // onChange={(checked) => {
                    //   this.setState({ isMandatoryFile: checked })
                    // }}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">
                    Data Frequency By File Type
                  </label>
                </Col>
                <Col className="form-field" md="8">
                  <FormSelect
                    id="dataFrequencyByFileType"
                    onChange={this.onChangeDataFrequencyByFileType}
                  >
                    <option>Select Data Frequency</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </FormSelect>
                </Col>
              </Row>

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="4">
                  <label htmlFor="masterTransactionFields">Master Transaction Fields</label>
                </Col>
                <Col className="form-field" md="8">
                  <Row>
                    <Col className="form-field" md="4">
                      <FormInput
                        id="fieldName"
                        placeholder="Field Name"
                        value={this.state.fieldName}
                        onChange={this.onChangeFieldName}
                      />
                    </Col>
                    <Col className="form-field" md="4">
                      <FormSelect
                        id="apiKey"
                        onChange={this.onChangeApiKey}
                      >
                        <option>Select Master API Key</option>
                        {apiKeyArray.length > 0 && (
                         apiKeyArray.map((item, index) => (
                            <option key={index+1} value={item.fieldName}>{item.fieldName}</option>
                         ))
                        )
                      }
                      </FormSelect>
                    </Col>
                    <Col className="form-field" md="3">
                      <FormSelect
                        id="dataType"
                        onChange={this.onChangeDataType}
                      >
                        <option>Select Data Type</option>
                        <option value="Number">Number</option>
                        <option value="String">String</option>
                        <option value="Date">Date</option>
                      </FormSelect>
                    </Col>
                    <Col className="form-field" md="1">
                      <Button
                        variant="primary"
                        onClick={this.handleAddFieldForm}
                      >
                        <FcPlus /> {/*Add*/}
                      </Button>
                    </Col>
                  </Row>
                  <Row
                      className="form-group-row ml-1 mr-1 border-bottom-button" >
                      <Col className="form-label" md="4">
                        <label htmlFor="filedName">Field Name</label>
                      </Col>
                
                      <Col className="form-label" md="4">
                        <label htmlFor="dataType">Api Key</label>
                      </Col>

                      <Col className="form-label" md="3">
                        <label htmlFor="dataType">Data Type</label>
                      </Col>
                      
                      <Col className="form-label" md="1">
                        <label htmlFor="dataType">Action</label>
                      </Col>
                  </Row>
                  {localStoreFieldData &&
                    localStoreFieldData.map((item, index) => {
                      return (
                        <Row
                          className="form-group-row ml-1 mr-1 border-bottom-button"
                          key={index + 1}
                        >
                         
                          <Col className="form-field" md="4">
                            {item.fieldName}
                          </Col>
                          <Col className="form-field" md="4">
                            {item.apiKey}
                          </Col>
                          <Col className="form-field" md="3">
                            {item.dataType}
                          </Col>
                          <Col className="form-label" md="1">
                            <div className="closeBtn" onClick={this.deleteFromLocalStorage.bind(this, item.fieldName)} aria-label="Close">
                              <TiDeleteOutline />
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>
              <Row>
                <Button
                  variant="primary"
                  className="mt-3"
                  onClick={this.handleAddFileForm}
                >
                  <FcPlus /> Save File
                </Button>
              </Row>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default CreateProject;
